import { ElMessage } from 'element-plus'

export default {
    toShowMessage: (message, type) => {
        ElMessage({
            message: message,
            type: type,
        })
    }
}